import { useMutation, useQueryClient } from "@tanstack/react-query";
import createACHWithdrawalV1 from "../requests/createACHWithdrawalV1";
import { keyMaker } from "./useGetACH";
export default function useCreateACHWithdrawalV1(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (withdrawal) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return await createACHWithdrawalV1(withdrawal, config);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: keyMaker(config),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useCreateACHWithdrawalV1.js.map